import { $toast } from "vuetify-snackbar-toast";
import store from "@/store";
import authService from "../../Services/AuthService";

const permitirRoles = (rolesPermitidos) => async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await authService.syncUserWithStore();
  }
  currentUser = store.getters["Auth/user"];

  if (currentUser && !rolesPermitidos.includes(currentUser.roleName)) {
    try {
      $toast.warn("Você não tem permissão para acessar esta página");
    } catch (error) {
      // $toast só fica pronto depois que o app monta; numa navegação fria
      // (URL acessada direto, antes do snackbar registrar seu updateFunction)
      // essa chamada pode falhar — não deve impedir o redirecionamento.
    }
    next({ name: "home" });
    return;
  }

  next();
};

export default permitirRoles;
